import { useContext, useCallback } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider.js';
import { useToken } from './useToken.js';
const useUserDomains = () => {
  const context = useContext(AuthenticationContext);
  const {
    fetchToken
  } = useToken();
  const handleSetUserDomain = useCallback(async entitySelection => {
    var _a;
    const token = await fetchToken();
    if (token) {
      return (_a = context.setUserDomain) == null ? void 0 : _a.call(context, token, entitySelection);
    }
  }, [fetchToken]);
  return {
    domains: context.domains,
    setUserDomain: handleSetUserDomain
  };
};
export { useUserDomains as default, useUserDomains };